"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargingSessionSerialization = void 0;
const ChargingSessionAttemptSerialization_1 = require("./ChargingSessionAttemptSerialization");
class ChargingSessionSerialization {
    static serialize(entity) {
        const copy = { ...entity };
        copy.first_attempt_of_charging = entity.first_attempt_of_charging
            ? entity.first_attempt_of_charging.getTime() * 1000000
            : undefined;
        copy.attempts = entity.attempts?.map((field) => field
            ? JSON.parse(ChargingSessionAttemptSerialization_1.ChargingSessionAttemptSerialization.serialize(field))
            : undefined);
        return JSON.stringify(copy);
    }
    static deserialize(msg) {
        const entity = JSON.parse(msg);
        const copy = { ...entity };
        copy.first_attempt_of_charging = entity.first_attempt_of_charging
            ? new Date(entity.first_attempt_of_charging / 1000000)
            : undefined;
        copy.attempts = entity.attempts?.map((field) => field
            ? ChargingSessionAttemptSerialization_1.ChargingSessionAttemptSerialization.deserialize(JSON.stringify(field))
            : undefined);
        return copy;
    }
}
exports.ChargingSessionSerialization = ChargingSessionSerialization;
